import { Component, Input } from '@angular/core';

/**
 * Full-height navy gradient surface with the decorative teal wave SVG.
 * Shared backdrop for every auth screen (sign-in, claim, forgot, deactivated).
 * `dim` lowers the wave opacity for dead-end screens (deactivated / not-found).
 */
@Component({
  selector: 'app-auth-bg',
  standalone: true,
  template: `
    <svg
      class="auth-bg__wave"
      [class.auth-bg__wave--dim]="dim"
      viewBox="0 0 400 300"
      preserveAspectRatio="none"
      aria-hidden="true">
      <path d="M0,100 Q100,60 200,90 T400,80 L400,0 L0,0 Z" fill="#00B4A8" />
      <path d="M0,160 Q120,120 220,140 T400,130 L400,0 L0,0 Z" fill="#00B4A8" opacity="0.5" />
    </svg>
    <ng-content></ng-content>
  `,
  styles: [
    `
      :host {
        position: relative;
        display: flex;
        flex-direction: column;
        min-height: 100%;
        overflow: hidden;
        color: #fff;
        background: linear-gradient(175deg, #0d346d 0%, #0a2550 55%, #081b3b 100%);
      }
      .auth-bg__wave {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        width: 100%;
        height: 300px;
        opacity: 0.14;
        pointer-events: none;
      }
      .auth-bg__wave--dim {
        opacity: 0.07;
      }
    `
  ]
})
export class AuthBgComponent {
  @Input() dim = false;
}
